import { render } from "./EditProposalArguments.vue?vue&type=template&id=77d95913&scoped=true"
import script from "./EditProposalArguments.vue?vue&type=script&lang=js"
export * from "./EditProposalArguments.vue?vue&type=script&lang=js"

import "./EditProposalArguments.vue?vue&type=style&index=0&id=77d95913&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d95913"]])

export default __exports__